import { ModelState } from '@/pages/aigc/pages/Text2SQL/interfaces';
import { getChatResult } from '@/pages/aigc/pages/Text2SQL/service';
import { v4 as uid } from 'uuid';
import axios from 'axios';
import { objectToFormData } from '@/pages/aigc/utils/utils';

let source = axios.CancelToken.source();
const initState = (): ModelState => ({
  currentGame: null, // 当前的业务游戏的信息
  relevantTables: undefined, // 聊天返回的表数据, 显示在右侧
  sqlInfo: null, // 聊天返回的SQL代码, 显示在右侧
  messages: [],
  chatLoading: false, // 聊天加载态, 需要用来判断表格和SQL的加载态
  chatError: null, // 聊天的
  sessionId: uid(),
});

export const namespace = 'Aigc/Text2SQL';

export default {
  namespace,
  state: initState(),
  reducers: {
    changeChatLoading(state: ModelState, action: any) {
      return { ...state, chatLoading: action };
    },

    // 更新聊天消息
    updateMessage(state: ModelState, action: any) {
      const { message, ...other } = action.payload;

      const messages = message ? [...state.messages, message] : state.messages;
      return { ...state, messages, ...other };
    },

    // 清空操作
    resetState(state: ModelState, action: any) {
      const { payload } = action;
      const resetState: ModelState = initState();
      resetState.currentGame = payload.currentGame || state.currentGame;
      resetState.messages = payload.messages;
      return resetState;
    },
  },
  effects: {
    // 获取聊天对话结果
    *fetchChat({ payload }: { payload: any; callback: Function; }, { put, select }: { put: any; select: any; }) {
      try {
        yield put({
          type: 'changeChatLoading',
          payload: true,
        });
        const { relevantTables, sqlInfo, sessionId, currentGame } = yield select((state) => state[namespace]);
        const newSessionId = payload.isReset ? uid() : sessionId;
        const parmas = {
          game: currentGame.game_code,
          session_id: newSessionId,
          table_info_row: payload.isReset ? '' : JSON.stringify(relevantTables),
          language: payload.language,
          text: payload.text,
        };
        // 后端要求上传FormData格式的参数
        const result = yield getChatResult(objectToFormData(parmas), source.token);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const { desc, row_id, table_info, sql, gpt_desc } = result;
        yield put({
          type: 'updateMessage',
          payload: {
            chatLoading: false,
            chatError: null,
            message: {
              // 还需要补充对错误消息的判断
              type: 'text',
              position: 'left',
              content: desc,
              status: 'end',
            },
            relevantTables: table_info || relevantTables,
            sqlInfo: sql
              ? {
                code: sql,
                desc: gpt_desc,
                id: row_id,
              }
              : null,
            sessionId: newSessionId,
          },
        });
      } catch (e) {
        // e 可能有undefined, e.msg, e.message 三种情况
        console.error('获取聊天消息错误: ', e?.message, e);

        const messagePayload = {
          chatLoading: false,
          chatError: e?.code === 999 ? undefined : e,
          message: {
            type: 'error',
            position: 'left',
            content: e?.message || e?.msg || payload.isEn ? 'System error! Please try again.' : '系统错误! 请再试一次。',
            status: 'end',
            state: 'error',
          },
        };
        e?.code !== 999 && (messagePayload.sqlInfo = null);

        yield put({
          type: 'updateMessage',
          payload: messagePayload,
        });
      }
    },
    // 取消本次聊天请求
    *cancelFetchChat({ payload }: any) {
      source.cancel(payload.isEn ? ' Stop generating!' : '结果生成过程已被中断!');
      source = axios.CancelToken.source();
    },

    // 重新生成数据表或SQL数据
    *rebuildTableOrSql({ payload }: any, { put }: any) {
      try {
        const { message, isEn, isReset, isSyntaxIncorrect } = payload;
        yield put({
          type: 'updateMessage',
          payload: {
            message: {
              type: 'text',
              position: 'right',
              status: 'end',
              content: message,
            },
          },
        });
        yield put({
          type: 'fetchChat',
          payload: {
            language: isEn ? 'en' : 'zh',
            text: isSyntaxIncorrect || message,
            isReset,
          },
        });
      } catch (e) { }
    },
  },
};
